import { baseApi } from './baseApi';
import type { UserOption } from './types';

/** Small lists for pickers and filters (any signed-in user). */
const lookupsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    userOptions: build.query<UserOption[], undefined>({
      query: () => '/lookups/users',
      providesTags: ['UserOption'],
    }),
  }),
});

export const { useUserOptionsQuery } = lookupsApi;
